import { useEffect, useContext, useState } from "react";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import ChartsHandler from "../../../../components/Charts/ChartsHandler.tsx";
import "./Dashboard.css";
import DadosUsuarioRedux from "../../../../contexts/Usuario";
import { Card } from "primereact/card";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import { motion } from "framer-motion";
import { getDashEmbarque1Search } from "../../../../services/ModuloGerenciador/Search";
import FiltrosRedux from "../../../../contexts/Filtros";
import iconeImprimir from "../../../../images/iconeImprimir.png";
import iconeProximo from "../../../../images/iconeProximo.png";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Cidade Origem",
		field: "cidadeOrigem",
	},
	{
		nomeColuna: "Estado Origem",
		field: "estadoOrigem",
	},
	{
		nomeColuna: "Cidade Destino",
		field: "cidadeDestino",
	},
	{
		nomeColuna: "Estado Destino",
		field: "estadoDestino",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
];

function Dashboard() {
	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { profile, hasRegra } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

	const [values, setValues] = useState({});

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [openToastErro, setOpenToastErro] = useState(false);

	const [textoErro, setTextoErro] = useState("");

	const [dadosEmbarqueFilial, setDadosEmbarqueFilial] = useState([]);

	const [dadosEmbarquePrazo, setDadosEmbarquePrazo] = useState([]);

	const [dadosPrazoTodos, setDadosPrazoTodos] = useState([]);

	const [dadosEntregaPrazo, setDadosEntregaPrazo] = useState([]);

	const [dadosEstadoOrigem, setDadosEstadoOrigem] = useState([]);

	const [dadosEstadoDestino, setDadosEstadoDestino] = useState([]);

	const [numeroEmbarque, setNumeroEmbarques] = useState(0);

	const [loading, setLoading] = useState(true);

	const navigate = useNavigate();

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const imprimir = () => {
		window.print();
	};

	const proxPage = () => {
		navigate("/segundo-dashboard");
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Dashboard"));
		}
	}, [profile?.token]);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const limpar = () => {
		buscarSearchReset();
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getDashEmbarque1Search(
			dadosUsuarioRedux.token,
			pesquisaFormatada,
			valuesPesquisa.contexto || "todos",
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				setNumeroEmbarques(result.data.numeroEmbarques);
				setDadosEmbarquePrazo(result.data.pagina.grafico1.pizza);
				setDadosEntregaPrazo(result.data.pagina.grafico2.pizza);
				setDadosPrazoTodos(result.data.pagina.grafico3.pizza);
				setDadosEstadoOrigem(result.data.pagina.grafico4.pizza);
				setDadosEstadoDestino(result.data.pagina.grafico5.pizza);
				setDadosEmbarqueFilial(result.data.pagina.grafico6.barra);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarSearchReset = async () => {
		setLoading(true);
		const pesquisaFormatada = "undefined=undefined";
		await getDashEmbarque1Search(
			dadosUsuarioRedux.token,
			pesquisaFormatada,
			"todos",
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				setNumeroEmbarques(result.data.numeroEmbarques);
				setDadosEmbarquePrazo(result.data.pagina.grafico1.pizza);
				setDadosEntregaPrazo(result.data.pagina.grafico2.pizza);
				setDadosPrazoTodos(result.data.pagina.grafico3.pizza);
				setDadosEstadoOrigem(result.data.pagina.grafico4.pizza);
				setDadosEstadoDestino(result.data.pagina.grafico5.pizza);
				setDadosEmbarqueFilial(result.data.pagina.grafico6.barra);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	useEffect(() => {
		if (!!valuesPesquisa.contexto) {
			buscarSearch();
		}
	}, [valuesPesquisa.contexto]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="Prazos e UF Origem Destino" />
			<div className="dashboards">
				<div className="header-dashboard1">
					<div className="flex2">
						<div className="item">
							<div className="numero-emb">
								<h3>Número de Viagens: {numeroEmbarque}</h3>
							</div>
						</div>
						<img
							onClick={imprimir}
							className="imagens-faturamentos"
							src={iconeImprimir}
						/>
					</div>
				</div>
				<div className="containerBuscas1">
					<div className="filtro-embarque">
						<FiltroV2
							classe="div-filtrar-faturamento-v2"
							classOption="select-options"
							itensFiltro={itensFiltro}
							valuesPesquisa={valuesPesquisa}
							setValuesPesquisa={setValuesPesquisa}
							buscarSearch={buscarSearch}
							limpar={limpar}
						/>
					</div>
					<div>
						<img
							onClick={proxPage}
							className="imagens-faturamentos"
							src={iconeProximo}
						/>
					</div>
				</div>
				<div className="charts">
					{!loading ? (
						<div>
							<div className="graficosCima">
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosEmbarquePrazo}
											type={"pie"}
											height="auto"
											width={570}
											title={"Embarque Prazo"}
										/>
									</Card>
								</div>
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosEntregaPrazo}
											type={"pie"}
											height="auto"
											width={570}
											title={"Entrega Prazo"}
										/>
									</Card>
								</div>
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosPrazoTodos}
											type={"pie"}
											height="auto"
											width={570}
											title={"Todos Prazos"}
										/>
									</Card>
								</div>
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosEstadoOrigem}
											type={"pie"}
											height="auto"
											width={570}
											title={"Estado Origem"}
										/>
									</Card>
								</div>
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosEstadoDestino}
											type={"pie"}
											height="auto"
											width={570}
											title={"Estado Destino"}
										/>
									</Card>
								</div>
								<div className="item">
									<Card>
										<ChartsHandler
											data={dadosEmbarqueFilial}
											type={"bar"}
											height="auto"
											width={570}
											title={"Embarque Por Filial"}
										/>
									</Card>
								</div>
							</div>
							<br></br>
							<br></br>
						</div>
					) : (
						<LoadingComponent />
					)}
				</div>
			</div>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</motion.div>
	);
}

export default Dashboard;
